export const toastIdentity = 'key';

/**
 *
 * spec:
 *  type: type of shown alert (info/error)
 *  message: message shown in the alert
 *  isHtml: {boolean} whether given message should be parsed as HTML
 *  key: key of the spec (will be used in the alert for identification)
 *  dismiss: object
 *    dismiss.timeout: boolean | number. If false, notification does not timeout.
 *                                       If true, use Alert's default timeout value
 *                                       Number specifies custom timeout value in ms
 *    dismiss.func: function{callback} function for dismissing the alert. callback is
 *                                        usually a dispatch to remove notification.
 */

export const NOONA_PASSWORD_RENEWAL_SUCCESS_TOAST = () => ({
  key: 'NOONA_PASSWORD_RENEWAL_SUCCESS_TOAST',
  modules: ['./src/components/service/noona/NoonaServiceCard.js'],
  spec: {
    type: 'info',
    message: 'password.renewal.successful',
    key: 'password.renewal.successful',
    dismiss: {
      timeout: 60000,
      func: (callback) => {
        callback('NOONA_PASSWORD_RENEWAL_SUCCESS_TOAST');
      },
    },
  },
});

// global toast/notifications
export const NOONA_PASSWORD_RENEWAL_FAILED_TOAST = () => ({
  key: 'NOONA_PASSWORD_RENEWAL_FAILED_TOAST',
  modules: ['./src/components/service/noona/NoonaServiceCard.js'],
  spec: {
    type: 'error',
    isHtml: true,
    message: 'password.renewal.failed',
    key: 'password.renewal.failed',
    dismiss: {
      timeout: false,
      func: (callback) => {
        callback('NOONA_PASSWORD_RENEWAL_FAILED_TOAST');
      },
    },
  },
});

export const APPOINTMENT_RESCHEDULE_SUCCESSFUL_TOAST = () => ({
  key: 'APPOINTMENT_RESCHEDULE_SUCCESSFUL_TOAST',
  modules: ['./src/components/timeline/TimelinePage.js'],
  spec: {
    type: 'info',
    message: 'appointment.reschedule.successful',
    key: 'appointment.reschedule.successful',
    dismiss: {
      timeout: 20000,
      func: (callback) => {
        callback('APPOINTMENT_RESCHEDULE_SUCCESSFUL_TOAST');
      },
    },
  },
});

export const APPOINTMENT_RESCHEDULE_FAILED_TOAST = (errorCode, stayOnPage) => ({
  key: 'APPOINTMENT_RESCHEDULE_FAILED_TOAST',
  modules: [
    stayOnPage
      ? './src/components/appointment/AppointmentReschedule.js'
      : './src/components/timeline/TimelinePage.js',
  ],
  spec: {
    type: 'error',
    message: errorCode,
    key: 'appointment.reschedule.failed',
    isHtml: true,
    dismiss: {
      timeout: false,
      func: (callback) => {
        callback('APPOINTMENT_RESCHEDULE_FAILED_TOAST');
      },
    },
  },
});

export const APPOINTMENT_RESERVATION_SUCCESSFUL_TOAST = () => ({
  key: 'APPOINTMENT_RESERVATION_SUCCESSFUL_TOAST',
  modules: ['./src/components/appointment/AppointmentsPage.js'],
  spec: {
    type: 'success',
    style: { textAlign: 'center' },
    message: 'appointment.reservation.successful',
    key: 'appointment.reservation.successful',
    dismiss: {
      timeout: 20000,
      func: (callback) => {
        callback('APPOINTMENT_RESERVATION_SUCCESSFUL_TOAST');
      },
    },
  },
});

export const APPOINTMENT_RESERVATION_FAILED_TOAST = (
  errorCode,
  stayOnPage
) => ({
  key: 'APPOINTMENT_RESERVATION_FAILED_TOAST',
  modules: [
    stayOnPage
      ? './src/components/appointment/AppointmentsPage.js'
      : './src/components/appointment/AppointmentsPage.js',
  ],
  spec: {
    type: 'error',
    style: { textAlign: 'center' },
    message: errorCode,
    key: 'appointment.reservation.failed',
    isHtml: true,
    dismiss: {
      timeout: false,
      func: (callback) => {
        callback('APPOINTMENT_RESERVATION_FAILED_TOAST');
      },
    },
  },
});

export const BIOBANK_REFUSAL_SUCCESSFUL_TOAST = () => ({
  key: 'BIOBANK_REFUSAL_SUCCESSFUL_TOAST',
  modules: ['./src/components/biobank/BioBank.js'],
  spec: {
    type: 'success',
    message: 'biobank.refusal.successful',
    key: 'biobank.refusal.successful',
    dismiss: {
      timeout: 20000,
      func: (callback) => {
        callback('BIOBANK_REFUSAL_SUCCESSFUL_TOAST');
      },
    },
  },
});

export const BIOBANK_CONSENT_SUCCESSFUL_TOAST = () => ({
  key: 'BIOBANK_CONSENT_SUCCESSFUL_TOAST',
  modules: ['./src/components/biobank/BioBank.js'],
  spec: {
    type: 'success',
    message: 'biobank.consent.successful',
    key: 'biobank.consent.successful',
    dismiss: {
      timeout: 20000,
      func: (callback) => {
        callback('BIOBANK_CONSENT_SUCCESSFUL_TOAST');
      },
    },
  },
});